import { render, staticRenderFns } from "./ProductStatuses.vue?vue&type=template&id=98f3d6a2&scoped=true"
import script from "./ProductStatuses.vue?vue&type=script&lang=js"
export * from "./ProductStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f3d6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f3d6a2')) {
      api.createRecord('98f3d6a2', component.options)
    } else {
      api.reload('98f3d6a2', component.options)
    }
    module.hot.accept("./ProductStatuses.vue?vue&type=template&id=98f3d6a2&scoped=true", function () {
      api.rerender('98f3d6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductStatuses.vue"
export default component.exports